import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Heading,
  useColorModeValue,
  Text,
  Button,
  ModalBody,
  ModalFooter,
  Divider,
} from '@chakra-ui/react';

function DisableMfaModal(props) {
  const modeText = useColorModeValue('secondaryDark08', '#DDDDDD');

  return (
    <Modal onClose={props.onClose} isOpen={props.isOpen} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Heading
            fontSize={{ base: '24px', lg: '32px' }}
            lineHeight="130%"
            textAlign="center"
          >
            Disable MFA
          </Heading>
        </ModalHeader>
        <Divider />
        <ModalBody>
          <Text
            textStyle="bodyFamilyMedium"
            color={modeText}
            textAlign="center"
          >
            Are you sure? Disabling MFA reduces your account security.
          </Text>
        </ModalBody>
        <ModalFooter display="flex" justifyContent="center" gap={8}>
          <Button variant="secondary" color="brand" onClick={props.onConfirm}>
            Disable
          </Button>
          <Button onClick={props.onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default DisableMfaModal;
